import { cn } from '@/lib/utils/tw-merge';

export const modalStyles = {
    base: 'ui-modal fixed inset-0 z-300 w-screen overflow-y-auto',
    container: 'flex min-h-full justify-center p-4 md:items-center',
    panel: cn(
        'ui-modal-panel',

        'relative',
        'pointer-events-auto',
        'duration-300 ease-out data-closed:transform-[scale(95%)] data-closed:opacity-0',
    ),
    /** The default look. A pattern that styles its own panel (`UiRouteModal`) opts out with `bare`. */
    panelLook: 'bg-body text-body p-10 size-full w-full h-full md:p-18',
    backdrop: 'fixed inset-0 bg-black/70 duration-300 ease-out data-closed:opacity-0',

    closeButton: cn(
        'absolute',
        'size-14 rounded-full',
        'flex items-center justify-center',
        'cursor-pointer',
        'z-50', // ensure the close button stays clickable above modal content
    ),
    closeButtonPositions: {
        'top-right': 'top-6 right-6',
        'top-left': 'top-6 left-6',
    },

    // Container scale steps (AGENTS.md → Design contract → Containers); `full` is full screen.
    sizes: {
        '4xs': 'max-w-page-4xs',
        '3xs': 'max-w-page-3xs',
        '2xs': 'max-w-page-2xs',
        xs: 'max-w-page-xs',
        sm: 'max-w-page-sm',
        md: 'max-w-page-md',
        lg: 'max-w-page-lg',
        xl: 'max-w-page-xl',
        full: '!size-full',
    },
} as const;
